import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { ModuleAccessService } from '../../services/module-access.service';

@Component({
  selector: 'app-sidebar',
  imports: [CommonModule],
  templateUrl: './sidebar.component.html'
})
export class SidebarComponent implements OnInit {
  @Input() isOpen = true;

  financeiroMenuOpen = false;
  productMenuOpen = false;
  customerMenuOpen = false;
  servicesMenuOpen = false;
  restaurantMenuOpen = false;
  salesMenuOpen = false;

  constructor(
    public router: Router,
    private moduleAccessService: ModuleAccessService
  ) {
    // Abre os submenus automaticamente quando a rota correspondente está ativa
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(() => {
      this.updateMenuStates();
    });
  }

  ngOnInit() {
    this.updateMenuStates();
  }

  updateMenuStates() {
    this.financeiroMenuOpen = this.isFinanceiroActive();
    this.productMenuOpen = this.isProductActive();
    this.customerMenuOpen = this.isCustomerActive();
    this.servicesMenuOpen = this.isServicesActive();
    this.restaurantMenuOpen = this.isRestaurantActive();
    this.salesMenuOpen = this.isSalesActive();
  }

  isActive(path: string, exact: boolean = false): boolean {
    if (exact) {
      return this.router.url === path;
    }
    return this.router.url.startsWith(path);
  }

  goTo(route: string) {
    this.router.navigate([route]);
  }

  hasModule(code: string): boolean {
    return this.moduleAccessService.hasModule(code);
  }

  toggleFinanceiroMenu() {
    if (!this.financeiroMenuOpen) {
      // Se nenhuma das rotas do submenu está ativa, navega para Receitas
      if (!this.isFinanceiroActive()) {
        this.goTo('/app/financial');
      }
    }
    this.financeiroMenuOpen = !this.financeiroMenuOpen;
  }

  toggleProductsMenu() {
    if (!this.productMenuOpen) {
      // Se nenhuma das rotas do submenu está ativa, navega para Produtos
      if (!this.isProductActive()) {
        this.goTo('/app/products');
      }
    }
    this.productMenuOpen = !this.productMenuOpen;
  }

  toggleCustomersMenu() {
    if (!this.customerMenuOpen) {
      // Se nenhuma das rotas do submenu está ativa, navega para Clientes
      if (!this.isCustomerActive()) {
        this.goTo('/app/customers');
      }
    }
    this.customerMenuOpen = !this.customerMenuOpen;
  }


  toggleServicesMenu() {
    if (!this.servicesMenuOpen) {
      if (!this.isServicesActive()) {
        this.goTo('/app/services');
      }
    }
    this.servicesMenuOpen = !this.servicesMenuOpen;
  }
  toggleRestaurantMenu() {
    if (!this.restaurantMenuOpen) {
      if (!this.isRestaurantActive()) {
        this.goTo('/app/restaurant/tables');
      }
    }
    this.restaurantMenuOpen = !this.restaurantMenuOpen;
  }

  isFinanceiroActive(): boolean {
    return [
      '/app/financial',
      '/app/financial/account-types',
      '/app/financial/expense-types',
      '/app/financial/revenue-types'
    ].some(route => this.isActive(route));
  }

  isProductActive(): boolean {
    return [
      '/app/products',
      '/app/measure-of-unities',
      '/app/brands',
      '/app/groups',
      '/app/sectors',
      '/app/subgroups',
      '/app/promotions',
      '/app/families'
    ].some(route => this.isActive(route));
  }

  isCustomerActive(): boolean {
    return [
      '/app/customers',
      '/app/customers/pending-approval'
    ].some(route => this.isActive(route));
  }

  isServicesActive(): boolean {
    return [
      '/app/services',
      '/app/service-orders',
      '/app/service-order-templates'
    ].some(route => this.isActive(route));
  }

  isRestaurantActive(): boolean {
    return [
      '/app/restaurant/tables',
      '/app/restaurant/comandas'
    ].some(route => this.isActive(route));
  }

  toggleSalesMenu() {
    if (!this.salesMenuOpen) {
      // Se nenhuma das rotas do submenu está ativa, navega para Vendas
      if (!this.isSalesActive()) {
        this.goTo('/app/sales');
      }
    }
    this.salesMenuOpen = !this.salesMenuOpen;
  }

  isSalesActive(): boolean {
    return [
      '/app/sales',
      '/app/pre-vendas'
    ].some(route => this.isActive(route));
  }
}
